/* tutor-3 (B.1, P1): LO QUE LA PAGINA DEL TUTOR RECUERDA EN EL APARATO, POR CUENTA.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   - La ULTIMA conversacion abierta en la pagina: `sb_tutor_ultima:<user_id>`.
   - El BORRADOR del cuadro, uno por conversacion y uno para la conversacion nueva:
     `sb_tutor_borrador:<user_id>:<conv_id>` y `sb_tutor_borrador:<user_id>:nueva`.
   Solo TEXTO (las fotos elegidas son archivos locales y no se recuerdan). Un borrador vacio se borra. Cada lectura y
   escritura va en `try`: sin `localStorage` (ventana privada, sitio bloqueado) la pagina funciona igual, sin
   recordar nada. */

export const NUEVA = 'nueva';
const ULTIMA = 'sb_tutor_ultima:';
const BORRADOR = 'sb_tutor_borrador:';

function leer(llave) {
  try { return window.localStorage.getItem(llave); } catch (e) { return null; }
}

function escribir(llave, valor) {
  try {
    if (valor) window.localStorage.setItem(llave, valor);
    else window.localStorage.removeItem(llave);
  } catch (e) { /* sin recuerdo */ }
}

export function llaveDelBorrador(userId, convId) {
  return `${BORRADOR}${userId}:${convId || NUEVA}`;
}

export function leerBorrador(userId, convId) {
  if (!userId) return '';
  return leer(llaveDelBorrador(userId, convId)) || '';
}

export function guardarBorrador(userId, convId, texto) {
  if (!userId) return;
  escribir(llaveDelBorrador(userId, convId), String(texto || '').trim() ? String(texto) : '');
}

export function borrarBorrador(userId, convId) {
  guardarBorrador(userId, convId, '');
}

export function leerUltima(userId) {
  return userId ? leer(`${ULTIMA}${userId}`) || null : null;
}

export function guardarUltima(userId, convId) {
  if (userId) escribir(`${ULTIMA}${userId}`, convId || '');
}

export function olvidarUltima(userId) {
  guardarUltima(userId, '');
}
